import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Input, Component, ChangeDetectionStrategy, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { SnFormFieldConfig } from '@lib/form';
import { TranslationService } from '@lib/translation/services';
import { SnUserFieldsGeneratorService } from '@lib/users';

export interface IResetPasswordFormModel {
  email?: string;
}

@Component({
  selector: 'sn-reset-password-form',
  templateUrl: './reset-password-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResetPasswordFormComponent implements OnInit, OnDestroy {

  @Input()
  public readonly form = new UntypedFormGroup({});

  @Input()
  public formModel: IResetPasswordFormModel = {};

  public formFields: SnFormFieldConfig[] = [];
  private readonly _destroy$ = new Subject<void>();

  constructor(
    private readonly _userFieldsGenerator: SnUserFieldsGeneratorService,
    private readonly _translationService: TranslationService,
  ) {}

  public ngOnInit(): void {
    this._translationService.translationReady$().pipe(
      takeUntil(this._destroy$)
    ).subscribe(() => {
      this.formFields = [
        this._userFieldsGenerator.getEmailField({
          templateOptions: {
            floatLabel: 'always',
          },
          focus: true,
        }),
      ];
    });
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
